<div fxLayout="column" fxLayoutGap="5px">
  @for (customField of filtered(); track customField) {
    <div fxLayoutGap="5px">
      <custom-field-inline-editor
        class="inline-attribute-editor"
        fxFlex="99"
        [editable]="editable"
        [customFieldValues]="
          customFieldValues | customFieldValueByIdPipe: customField.id
        "
        [customField]="customField"
        [saveFn]="saveFn"
        [deleteFn]="deleteFn"
        [useDescription]="useDescription"
        [id]="customField.id"
        [entityId]="entityId"
        [attributeEditorMode]="attributeEditorMode"
        (addOrUpdateComplexValue)="addOrUpdateComplexValue.emit($event)"
      ></custom-field-inline-editor>
    </div>
  }
</div>
